var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('img',{attrs:{"src":require("../assets/image/error/error.png"),"alt":""}}),_c('p',[_vm._v("相关已被删除，看看别的吧")])])}]

export { render, staticRenderFns }